"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFormValues = void 0;
const parseFormValues = (modifiedAttribute) => {
    const { values } = modifiedAttribute, attribute = __rest(modifiedAttribute, ["values"]);
    const newValues = values.filter(({ readonly }) => !readonly);
    const valuesWithNewGuideline = values.filter(({ isDescriptionChanged }) => isDescriptionChanged);
    return Object.assign(Object.assign({ isDescriptionChanged: modifiedAttribute.isDescriptionChanged }, attribute), { valuesWithNewGuideline,
        newValues });
};
exports.parseFormValues = parseFormValues;
